
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[teamSlug]",
      function () {
        return require("private-next-pages/[teamSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[teamSlug]"])
      });
    }
  